import React, { useMemo } from "react";
import { HorizontalBar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const HospitalFulfillmentRateChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data) return null;

    return {
      labels: data.regions.map((region) => t(region)),
      datasets: [
        {
          label: t("Fulfillment Rate (%)"),
          data: data.rates,
          backgroundColor: "#28a745",
          borderColor: "#28a745",
          borderWidth: 1,
          barThickness: 25,
          borderRadius: 4,
        },
      ],
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 100,
            fontColor: "#666",
            callback: (value) => value + "%",
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          scaleLabel: {
            display: true,
            labelString: t("Fulfillment Rate (%)"),
            fontColor: "#666",
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: "#666",
          },
          gridLines: {
            display: false,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem) => {
          return `${t("Fulfillment Rate")}: ${tooltipItem.xLabel}%`;
        },
      },
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "250px", position: "relative" }}>
      <HorizontalBar data={chartData} height={250} options={options} />
    </div>
  );
};

export default HospitalFulfillmentRateChart;
